import styles from './DropshippingPage.module.scss';
import cn from 'classnames';
import CompleteTab from './tabs/CompleteTab.tsx';
import FilterIcon from '@assets/icons/filter.svg';
import InProcessTab from './tabs/InProcessTab.tsx';
import NewTab from './tabs/NewTab.tsx';
import Page from '@components/Page/Page.tsx';
import useTab from '@hooks/useTab';
import InfoPanel, { InfoPanelType } from "@components/InfoPanel";
import { Button, ButtonSize, ButtonType } from '@components/Button';
import { TabsContent, TabsList } from '@components/Tabs/Tabs.tsx';
import { useCompleteCounter, useInProcessCounter, useOzonCounter } from '@api/apiClient/dropshipping';
import { useSellersCounter } from '@contexts/SellersCounterContext';
import { useQueryClient } from "react-query";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { VITE_APP_DISABLE_DROPSHIPPING } from "@utils/config";

const disableHours = 5;

const DropshippingPage = () => {
  const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false);

  const { sellersNotFound } = useSellersCounter();
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const { data: completeTotal } = useCompleteCounter(!sellersNotFound);
  const { data: inProcessTotal, refetch: inProcessRefetch } = useInProcessCounter(!sellersNotFound);
  const { data: ozonTotal, refetch: ozonRefetch } = useOzonCounter(!sellersNotFound);

  const onUpdate = () => {
    inProcessRefetch();
    ozonRefetch();
    queryClient.invalidateQueries(
      { queryKey: ["getWallet"] }
    );
  };

  const tabs = [
    {
      id: 'new',
      title: t('dropshipping.newTab.title'),
      content: (
          <NewTab
              handlerOnUpdate={onUpdate}
              isFilterOpen={isFilterOpen}
              setIsFilterOpen={setIsFilterOpen}
          />
      ),
      count: ozonTotal
    },
    {
      id: 'inProcess',
      title: t('dropshipping.inProcessTab.title'),
      content: (
          <InProcessTab
              handlerOnUpdate={onUpdate}
              isFilterOpen={isFilterOpen}
              setIsFilterOpen={setIsFilterOpen}
          />
      ),
      count: inProcessTotal,
      disable: sellersNotFound
    },
    {
      id: 'Complete',
      title: t('dropshipping.completeTab.title'),
      content: (
          <CompleteTab
              isFilterOpen={isFilterOpen}
              setIsFilterOpen={setIsFilterOpen}
          />
      ),
      count: completeTotal,
      disable: sellersNotFound
    }
  ];

  const { activeTab, setActiveTab } = useTab(tabs);

  return (
      <Page title={t('dropshipping.title')}>
        <div className={styles.tabsRow}>
          <TabsList
              onChange={setActiveTab}
              tabs={tabs}
              value={activeTab}
          />
          {!sellersNotFound && (
              <div className={styles.filters}>
                <Button
                    className={cn(isFilterOpen ? styles.filterBtnActive : styles.filterBtnInactive)}
                    icon={FilterIcon}
                    onClick={() => setIsFilterOpen(!isFilterOpen)}
                    size={ButtonSize.S}
                    type={ButtonType.ROUNDED}
                    title={t('filters.filters')}
                />
              </div>
          )}
        </div>
        <TabsContent
            tab={tabs.find((tab) => (tab.id === activeTab))}
        />
      </Page>
  );
};

const DropshippingPageContainer = () => {
  const { t } = useTranslation();
  if (VITE_APP_DISABLE_DROPSHIPPING) {
    return (
      <Page title={t('dropshipping.title')}>
        <InfoPanel
          description={t('dropshipping.disabledDesciption')}
          title={disableHours
            ? t("dropshipping.disabledTitleWithTime", { count: disableHours })
            : t("dropshipping.disabledTitle")
          }
          type={InfoPanelType.WARNING}
        />
      </Page>
    )
  }
  return (<DropshippingPage />);
}

export default DropshippingPageContainer;
